import isString from "lodash/isString";

// length of string should be larger than one
export default function requireMinimumLength(str) {
    return isString(str) && str.length > 1;
}

